// eslint-disable-next-line import/prefer-default-export
export const SET_MODAL = 'canvasModalTypes/SET_MODAL';
